"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serialize = void 0;
var cloud_elementory_protocol_1 = require("@wix/cloud-elementory-protocol");
var serialize = function (args) { return JSON.stringify((0, cloud_elementory_protocol_1.convertToCustomFormat)(__spreadArray([], args, true))); };
exports.serialize = serialize;
//# sourceMappingURL=serialize.js.map